export type PoCatalogItemType = "INGREDIENT" | "RETAIL_VARIANT";

export type PoCatalogPick = {
  itemType: PoCatalogItemType;
  itemId: string;
  label: string;
};

export function poCatalogItemKey(
  itemType: PoCatalogItemType,
  itemId: string,
): string {
  return `${itemType}:${itemId}`;
}
